__turbopack_context__.v({
  "htmlRenderer": "_6OwQlG_htmlRenderer",
});
